import React from 'react';
import { useRouteMatch } from 'react-router';
import moment from 'moment';
import { declOfNum } from '../../../../../../helpers/dspx-utils';
import styles from './FileListItem.module.scss';
import cn from 'classnames';

const FileListItem = ({ file }) => {
  const match = useRouteMatch('/Debts/file/:id') || { params: {} };
  const {
    params: { id },
  } = match;

  return (
    <div
      className={cn(styles.root, {
        [styles.active]: Number(id) === Number(file.fileId),
      })}
    >
      <div className={styles.nameDebts}>{file?.fileLoadingName}</div>
      <div className={styles.info_block}>
        {file.noticeCount && (
          <div className={styles.noticeCount}>
            {file.noticeCount}{' '}
            {declOfNum(file.noticeCount, [
              'оповещение',
              'оповещения',
              'оповещений',
            ])}
          </div>
        )}
      </div>
      <div className={styles.bottomBlock}>
        <span className={styles.workerName}>{file.workerName}</span>
        <span className={styles.createDate}>
          {moment(file.uploadTime).format('DD.MM.YYYY HH:mm')}
        </span>
      </div>
    </div>
  );
};

export default FileListItem;
